import { useId } from 'react';

export default function RestaurantMeta({ rating, reviewsCount, time, cuisine }){
	const uid = useId().replace(/:/g, '');
	const ratingText = String(rating ?? '').trim();
	const reviewsText = String(reviewsCount ?? '').trim();
	const hasAny =
		(ratingText !== '') ||
		(reviewsText !== '') ||
		(time !== undefined && time !== null && String(time).trim() !== '') ||
		(cuisine !== undefined && cuisine !== null && String(cuisine).trim() !== '');

	if (!hasAny) return null;

	const ratingNumber = ratingText ? Number(ratingText) : NaN;
	// Only show Google icon + stars when we have a real rating (avoid empty string => 0.0).
	const safeRating =
		Number.isFinite(ratingNumber) && ratingNumber > 0
			? Math.max(0, Math.min(5, ratingNumber))
			: null;

	return (
		<div className='meta-row d-flex align-items-center'>
			{safeRating !== null ? (
				<>
					<span className="meta-icon meta-icon--google" aria-hidden="true">
						<svg viewBox="0 0 24 24" width="20" height="20" role="img" focusable="false">
							<path
								fill="#EA4335"
								d="M12 10.2v3.9h5.4c-.2 1.3-1.6 3.9-5.4 3.9-3.2 0-5.9-2.7-5.9-6s2.6-6 5.9-6c1.8 0 3 .7 3.7 1.3l2.5-2.4C16.7 3.5 14.6 2.6 12 2.6 6.9 2.6 2.8 6.7 2.8 12s4.1 9.4 9.2 9.4c5.3 0 8.8-3.7 8.8-8.9 0-.6-.1-1.1-.1-1.6H12z"
							/>
							<path
								fill="#34A853"
								d="M3.7 7.7l3.2 2.3C7.8 8 9.7 6.6 12 6.6c1.8 0 3 .7 3.7 1.3l2.5-2.4C16.7 3.5 14.6 2.6 12 2.6 8.5 2.6 5.4 4.6 3.7 7.7z"
								opacity=".001"
							/>
							<path
								fill="#FBBC05"
								d="M12 21.4c2.5 0 4.6-.8 6.1-2.2l-2.8-2.3c-.8.5-1.8.9-3.3.9-2.5 0-4.6-1.7-5.3-4l-3.2 2.5c1.7 3.1 4.8 5.1 8.5 5.1z"
							/>
							<path
								fill="#4285F4"
								d="M20.7 12.5c0-.6-.1-1.1-.2-1.6H12v3.9h5.4c-.3 1-1 2.3-2.5 3.1l2.8 2.3c1.6-1.5 3-3.8 3-7.7z"
							/>
						</svg>
					</span>

					<span className="meta-stars" aria-hidden="true">
						{Array.from({ length: 5 }).map((_, i) => {
							const fill = Math.max(0, Math.min(1, safeRating - i));
							const pct = Math.round(fill * 100);
							const gradId = `star-${uid}-${i}-${pct}`;
							return (
								<span key={i} className="meta-star">
									<svg viewBox="0 0 24 24" width="16" height="16" focusable="false">
										<defs>
											<linearGradient id={gradId}>
												<stop offset={`${pct}%`} stopColor="#F4B400" />
												<stop offset={`${pct}%`} stopColor="#E6E6E6" />
											</linearGradient>
										</defs>
										<path
											fill={`url(#${gradId})`}
											d="M12 17.3l-6.18 3.73 1.64-7.03L2 9.24l7.19-.62L12 2l2.81 6.62 7.19.62-5.46 4.76 1.64 7.03z"
										/>
									</svg>
								</span>
							);
						})}
					</span>

					<span className='rating'>{safeRating.toFixed(1)}</span>
				</>
			) : null}

			{reviewsText ? <span className='reviews'>({reviewsText})</span> : null}

			{time ? (
				<>
					<span className='seperator'>•</span>
					<span className='time'>{time}</span>
				</>
			) : null}

			{cuisine ? (
				<>
					<span className='seperator'>•</span>
					<span className='cuisine'>{cuisine}</span>
				</>
			) : null}
		</div>
	);
}

